import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/components/common/api';
import { FundingDocument, FundingRequest } from '../../../models/inModels/FundingRequest';
import { FundingRequestService } from '../../../services/funding/funding-request.service';
import { StorageService } from '../../../services/system/storage.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-funding-details',
  templateUrl: './funding-details.component.html',
  styleUrls: ['./funding-details.component.css']
})
export class FundingDetailsComponent implements OnInit {
  model: FundingRequest;
  loading = false;
  messages: Message[];
  requestId;
  uploading = false;
  downloading = false;
  error: Message[];
  selectedDocument: FundingDocument;
  selectedFunding: FundingRequest;
  constructor(
    private route: ActivatedRoute,
    private requestService: FundingRequestService,
    private router: Router,
    public storageService: StorageService,
    private confirmationService: ConfirmationService
  ) { 
    this.model = ({} as FundingRequest);
  }

  ngOnInit() {
    this.loading = true;

    this.route.paramMap.subscribe(params => {
      this.requestId = params.get('Id');
    });

    this.requestService.get(this.requestId).then(
      result => {
        this.model = result;
        this.model.Id = this.requestId;
        this.loading = false;
      },
      error => {
        this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }
  goBack(): void {
		this.router.navigate(['/funding']);
  }
  
  downloadPdf(document: FundingDocument) {
    this.selectedDocument = document;
    this.downloading = true;
    this.storageService.downloadFile(document.Id).subscribe(
      blob => {
        this.downloading = false;
        saveAs(blob, document.Name)
      },
      error => {
        this.downloading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  approve(fundingRequest: FundingRequest) {
    this.selectedFunding = fundingRequest;
		this.confirmationService.confirm({
			message: `Are you sure you want to approve this funding request?`,
			header: 'Confirmation',
			icon: 'fa fa-check',
			accept: () => {
				this.loading = true;
				this.requestService.approve(fundingRequest.Id).then(
          result => {
            this.selectedFunding = result;
            this.loading = false;
            this.messages = [];
            this.messages.push({ severity: 'success', summary: 'Success', detail: "Funding Request Approved" });
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
  }
  
  disapprove(fundingRequest: FundingRequest) {
		this.confirmationService.confirm({
			message: `Are you sure you want to approve this funding request?`,
			header: 'Confirmation',
			icon: 'fa fa-times',
			accept: () => {
				this.loading = true;
				this.requestService.disapprove(fundingRequest.Id).then(
          result => {
            this.selectedFunding = result;
            this.loading = false;
            this.messages = [];
            this.messages.push({ severity: 'success', summary: 'Success', detail: "Funding Request Disapproved" });
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/funding/funding-details/funding-details.component.ts